let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3S7Ze")).then(() => parcelRequire('jy7iD'));